import React, { useEffect, useRef, useState, useCallback } from "react"
import { ConsultaOrdemDeProducao, ConsultaOrdemDeProducaoFiltro, DadosOrdemDeProducao } from "./ConsultaOrdemDeProducao";
import { removerComponenteReact, renderizarComponentReact } from "../../renderizarOuRemoverComponentReact";
import { Dict } from "app/utils/Dict";
import { Breadcrumb2Container } from "../../breadcrumb2/Breadcrumb2Container";
import { OrdemDeProducaoContainer } from "../OrdemProducaoContainer";
import globalMU from "globalMU";
import { tratamentoErroPadrao } from "app/use-cases";
import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { PaginaPesquisaProdutoContainer } from "app/components/pesquisa-produtos/PaginaPesquisaProdutoContainer";
import { ProdutoFiltrado } from "app/types/IProduto";
import { CancelarGeracaoOrdemProducaoContainer } from "../CancelarGeracaoOrdemProducaoContainer";
import * as R from "ramda";
import { DadosSalvarOrdemProducao } from "app/types/OrdemProducao";
import { OrdemProducaoApi } from "app/api/classes/OrdemProducaoApi";

declare const window: any;

export type ConsultaOrdemDeProducaoContainerProps = {
    // Propriedades existentes
}

export const ConsultaOrdemDeProducaoContainer = (props: ConsultaOrdemDeProducaoContainerProps) => {

    const isMounted = useRef<boolean>(true)
    useEffect(() => () => { isMounted.current = false }, [])
    const [filtro, setFiltro] = useState<ConsultaOrdemDeProducaoFiltro | null>(null)
    const [paginaFiltro, setPaginaFiltro] = useState<number>(1)
    const [processando, setProcessando] = useState(false)
    const [pedirSenhaLiberacao, setPedirSenhaLiberacao] = useState<boolean>(false)
    const [mostrarConsultaOrdemProducao, setMostrarConsultaOrdemProducao] = useState(false)
    const [mostrarOrdemProducao, setMostrarOrdemProducao] = useState(false)
    const [mostrarCancelarGeracaoOP, setMostrarCancelarGeracaoOP] = useState(false) // 471071
    const [cancelamentoMultiplo, setCancelamentoMultiplo] = useState(false) // 471071
    const [mostrarPesquisaProduto, setMostrarPesquisaProduto] = useState(false)
    const [produtosFiltrados, setProdutosFiltrados] = useState<ProdutoFiltrado[]>([])
    const [colunaOrdenacao, setColunaOrdenacao] = useState<string>("Orçamento")
    const [ordemOrdenacaoDecrescente, setOrdemOrdenacaoDecrescente] = useState<boolean>(false)
    const [listaOrdemProducao, setListaOrdemProducao] = useState<Partial<PagedMessageResponse<DadosOrdemDeProducao>>>()
    const [ordemProducaoSelecionadoLista, setOrdemProducaoSelecionadoLista] = useState<DadosOrdemDeProducao[]>([])
    const [senhaLiberacao, setSenhaLiberacao] = useState<string>(null)


    const passosInterno = useRef<Dict<string, () => void>>(new Dict())


    const onSenhaValidada = (senhaValida: boolean, senha?: string) => { // 472375
        if (!isMounted.current) return

        if (senhaValida) {
            setPedirSenhaLiberacao(false)
            setSenhaLiberacao(senha)
            onGerarOrdemDeProducao(senha)
        } else {
            setSenhaLiberacao(null)
            globalMU.showWarnMessage("Senha inválida. Tente novamente.")
        }

    }

    const onGerarOrdemDeProducao = async (senhaLiberacao: string | null) => {// 472375
        if (!isMounted.current) return
        let pedirSenhaOP = false
        let ordemProducaoSelecionadoListaCopia = [...(ordemProducaoSelecionadoLista || [])]
        let listaOrdemProducaoCopia = { ...listaOrdemProducao }
        try {

            globalMU.blockUI()
            setProcessando(true)

            if (!ordemProducaoSelecionadoLista || ordemProducaoSelecionadoLista.length === 0) {
                globalMU.showErrorMessage("Nenhum produto selecionado para gerar a Ordem de Produção.")
                return
            }

            if (ordemProducaoSelecionadoLista.find(op => op.CodigoOrdemProducao !== undefined && op.CodigoOrdemProducao > 0)) {
                globalMU.showErrorMessage("Foi selecionada [Ordem de Produção] já gerada.")
                return
            }

            if (ordemProducaoSelecionadoLista.find(op => op.ExiteInsumoSemEstoque === 1 && senhaLiberacao === null)) {
                pedirSenhaOP = true
                setPedirSenhaLiberacao(true)
                globalMU.showWarnMessage("Informe a senha de liberação para gerar a Ordem de Produção.")
                return
            }


            try {

                let opSelecionadasListaOrdenadoPorNivelDescrescente = R.sortWith([
                    R.ascend(R.prop('NumeroPedido')),
                    R.ascend(R.prop('CodigoItem')),
                    R.descend(R.prop('Nivel'))
                ], ordemProducaoSelecionadoLista || [])

                // ordemProducaoSelecionadoLista.forEach(async op => 
                for (const op of opSelecionadasListaOrdenadoPorNivelDescrescente) {
                    {
                        globalMU.blockUI()

                        if (!isMounted.current) break // Isso vai sair do loop
                        const ordemProducao = await microuniversoApi.OrdemProducao.ObterDadosOrdemProducao({
                            CodigoItemPedido: op.CodigoItem,
                            CodigoOrdemProducao: op.CodigoOrdemProducao,
                            CodigoProduto: op.CodigoProduto,
                            QuantidadeItem: op.QuantidadeItem,
                            CodigoFilial: op.CodigoFilialOP,
                            Nivel: op.Nivel

                        }, op.NumeroPedido)
                        if (ordemProducao["HasErrors"] == undefined) {

                            try {

                                let dados: Partial<DadosSalvarOrdemProducao> = {
                                    DataInclusao: ordemProducao.Dados == null ? globalMU.converterObjetoDateParaDataFormatoEN(new Date()) : ordemProducao.Dados.DataInclusao,

                                    CodigoOrdemProducao: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.Id : ordemProducao.Dados.Id,
                                    CodigoFilial: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoFilial : ordemProducao.Dados.CodigoFilial,
                                    CodigoSituacao: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoSituacao : ordemProducao.Dados.CodigoSituacao,
                                    NumeroPedido: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.NumeroPedido : ordemProducao.Dados.NumeroPedido,
                                    CodigoCliente: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoCliente : ordemProducao.Dados.CodigoCliente,
                                    CodigoProduto: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoProduto : ordemProducao.Dados.CodigoProduto,
                                    Lote: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.Lote : ordemProducao.Dados.Lote,
                                    CodigoLinha: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoLinha : ordemProducao.Dados.CodigoLinha,
                                    Quantidade: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.Quantidade : ordemProducao.Dados.Quantidade,
                                    ItemPedido: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.ItemPedido : ordemProducao.Dados.ItemPedido,
                                    DataAprovacao: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.DataAprovacao : ordemProducao.Dados.DataAprovacao,
                                    DataEntrega: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.DataEntrega : ordemProducao.Dados.DataEntrega,
                                    DataProducao: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.DataProducao : ordemProducao.Dados.DataProducao,
                                    Terceirizado: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.Terceirizado : ordemProducao.Dados.Terceirizado,
                                    CodigoFornecedor: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoFornecedor : ordemProducao.Dados.CodigoFornecedor,
                                    InformacaoAdicional: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.InformacaoAdicional : ordemProducao.Dados.InformacaoAdicional,
                                }


                                let filtroSalvarOrdemProducao: Partial<OrdemProducaoApi.FiltroSalvarOrdemProducao> = {
                                    Dados: dados,
                                    DadosInsumoOrdemProducao: ordemProducao.DadosInsumoOrdemProducao,
                                    SenhaLiberacao: senhaLiberacao,
                                    DadosHistoricoOrdemProducao: null // ?????????????
                                }

                                if (!isMounted.current) break // Isso vai sair do loop
                                globalMU.blockUI()
                                const resposta = await microuniversoApi.OrdemProducao.SalvarOrdemProducao(filtroSalvarOrdemProducao)

                                if (resposta?.Resultado?.Sucesso) {
                                    await microuniversoApi.Comum.excluirControleDeExclusividade(op.NumeroPedido.toString(), "PEDICLICAD")
                                    globalMU.showSuccessMessage(resposta?.Resultado?.MensagemSucesso)
                                    // retira item da lista de ordem de produção selecionada

                                    ordemProducaoSelecionadoListaCopia = ordemProducaoSelecionadoListaCopia.filter((c) => !(c.CodigoProduto == op.CodigoProduto && c.CodigoItem == op.CodigoItem))

                                    listaOrdemProducaoCopia = {
                                        ...listaOrdemProducaoCopia,
                                        Entities: listaOrdemProducaoCopia?.Entities?.filter((c) => !(c.CodigoProduto == op.CodigoProduto && c.CodigoItem == op.CodigoItem))
                                    }
                                }
                                else {

                                    globalMU.showErrorMessage(resposta?.Resultado?.MensagemSucesso ?? "Erro ao gerar a ordem de produção.")
                                    break // Isso vai sair do loop
                                }
                            }
                            catch (error) {

                                globalMU.showErrorMessage(error.message)
                                break // Isso vai sair do loop
                            }
                            finally {
                                await microuniversoApi.Comum.excluirControleDeExclusividade(op.NumeroPedido.toString(), "PEDICLICAD")
                            }

                        }
                        else {

                            //globalMU.showErrorMessage(ordemProducao["Message"])
                            break // Isso vai sair do loop
                        }


                    }
                }
            } catch (e) {

                tratamentoErroPadrao(e)
            } finally {
                if (isMounted.current) {
                    setListaOrdemProducao(listaOrdemProducaoCopia)
                    //onPesquisar(paginaFiltro, filtro!, false) // pesquisar novamente para atualizar a lista
                    setOrdemProducaoSelecionadoLista(ordemProducaoSelecionadoListaCopia)
                }
            }



        } catch (e) {

            tratamentoErroPadrao(e)
        } finally {
            if (isMounted.current) {
                globalMU.unblockUI()
                if (!pedirSenhaOP) {
                    setProcessando(false)
                }

            }
        }
    }

    const onAlterarOrdenacao = useCallback(async (coluna: string, decrescente: boolean, filtro: ConsultaOrdemDeProducaoFiltro) => {
        if (!isMounted.current) return
        try {
            setColunaOrdenacao(coluna ?? "")
            setOrdemOrdenacaoDecrescente(decrescente)
            const filtroAlterado = {
                ...filtro,
                NumeroPagina: 1,
                ColunaOrdenacao: coluna,
                OrdemOrdenacaoDecrescente: decrescente
            }
            setFiltro(filtroAlterado)
            setPaginaFiltro(1)
            onPesquisar(1, filtroAlterado, false)
            setOrdemProducaoSelecionadoLista(null) // 472375
            setSenhaLiberacao(null) // 472375
        } catch (erro) {
            tratamentoErroPadrao(erro)
        }
    }, [])

    const onRemoverProdutoSelecionado = useCallback((produto: ProdutoFiltrado) => {

        if (!isMounted.current) return
        setProdutosFiltrados(prev =>
            prev.filter(p => p.Codigo !== produto.Codigo)
        );

        setFiltro(prev => ({
            ...prev!,
            ListaProdutosSelecionados: prev?.ListaProdutosSelecionados?.filter(cod => cod !== produto.Codigo) ?? []
        }));
    }, [])

    const onPesquisar = useCallback(async (pagina: number, filtro: ConsultaOrdemDeProducaoFiltro, clickBotaoPesquisar: boolean) => {

        if (!isMounted.current) return
        try {
            setProcessando(true)
            globalMU.blockUI()
            setPedirSenhaLiberacao(false)

            if (clickBotaoPesquisar) {
                setListaOrdemProducao(null)
            }

            const filtroAjustado = { ...filtro, NumeroPagina: pagina }
            setFiltro(filtroAjustado)
            if (!isMounted.current) return

            const resposta = await microuniversoApi.OrdemProducao.ListarPedidosOrdemProducao(filtroAjustado)

            if (!isMounted.current) return
            if (!("HasErrors" in resposta)) {


                setListaOrdemProducao(resposta)

                if (clickBotaoPesquisar) {

                    setOrdemProducaoSelecionadoLista(null)
                    setSenhaLiberacao(null) // 472375

                    setTimeout(() => {
                        // const objeto = document.getElementById("ConsultaOrdemDeProducao_BotaoPesquisarOP");
                        // if (objeto) {

                        //     objeto.scrollIntoView({ behavior: 'smooth', inline: 'nearest' });
                        // }
                        if (filtro.NumeroPedido > 7) {
                            globalMU.showInfoMessage("Número do orçamento informado. \nDemais campos de filtro foram ignorados.")
                        }
                    }, 100);
                }
            }
        } catch (e) {
            tratamentoErroPadrao(e);
        } finally {
            globalMU.unblockUI();
            setProcessando(false)
        }
    }, [])

    const listaOrdemProducaoRef = useRef(listaOrdemProducao)
    listaOrdemProducaoRef.current = listaOrdemProducao

    const processandoRef = useRef(processando)
    processandoRef.current = processando

    // Recebe a lista como parâmetro para poder ser chamada dentro de useCallback sem fechar sobre estado
    const ObterOrdemProducaoDescendentes = (lista: Partial<PagedMessageResponse<DadosOrdemDeProducao>>, item: DadosOrdemDeProducao): DadosOrdemDeProducao[] => {
        const filhos = lista?.Entities?.filter(op => op.CodigoItem == item.CodigoItem && op.IndexProdutoPai === item.Index)
        let retorno = [...filhos]

        if (!item.MensagemErro)
            retorno = [...filhos, item]

        filhos?.forEach(filho => {
            const descendentes = ObterOrdemProducaoDescendentes(lista, filho)
            descendentes?.forEach(descendente => {
                if (!descendente.MensagemErro) {
                    if (!retorno.find(r => r.CodigoItem === descendente.CodigoItem && r.Index === descendente.Index)) {
                        retorno.push(descendente)
                    }
                }
            })
        })
        return retorno
    }

    const toggleSelecionado = useCallback((ordemProducao: DadosOrdemDeProducao) => {
        if (!isMounted.current || processandoRef.current) return;
        if (ordemProducao.MensagemErro) {
            globalMU.showWarnMessage(ordemProducao.MensagemErro);
            return;
        }

        setOrdemProducaoSelecionadoLista(prev => {
            const listaAtual = prev || [];
            const achou = listaAtual.find((produtoOP) =>
                produtoOP.CodigoItem == ordemProducao.CodigoItem && produtoOP.Index == ordemProducao.Index
            )

            if (achou) {
                if (ordemProducao.Nivel >= 2) {
                    const pai = listaOrdemProducaoRef.current?.Entities?.find((c) => c.Index == ordemProducao.IndexProdutoPai && c.CodigoItem == ordemProducao.CodigoItem)
                    globalMU.showWarnMessage(`Caso a ordem de produção do insumo [${ordemProducao.CodigoProdutoMostrar}], filho do insumo [${pai?.CodigoProdutoMostrar}], não seja gerada neste momento, ela só poderá ser criada manualmente pelo módulo de PCP, sem vínculo com o pedido original.`)
                }
                return listaAtual.filter((c) => !(c.CodigoItem == ordemProducao.CodigoItem && c.Index == ordemProducao.Index))
            } else {
                if (ordemProducao.Nivel < 1) {
                    return [...listaAtual, ordemProducao];
                } else {
                    const descendentes = ObterOrdemProducaoDescendentes(listaOrdemProducaoRef.current, ordemProducao)
                    if (descendentes) {
                        return [...listaAtual, ...descendentes.filter(d => !d.MensagemErro)]
                    }
                    return [...listaAtual, ordemProducao]
                }
            }
        })
    }, [])


    const obterDadosParaFiltro = useCallback(async () => {
        if (!isMounted.current) return
        const resposta = await microuniversoApi.OrdemProducao.ObterDadosParaFiltroOrdeProducao()
        if (resposta["HasErrors"]) {
            return
        }
        if (!isMounted.current) return
        const listaVendedoresSelecionado = resposta.Vendedores?.length === 1
            ? [resposta.Vendedores[0].CodigoVendedor]
            : []

        const listaFiliaisSelecionada = resposta.Filiais?.length === 1
            ? [resposta.Filiais[0].Codigo]
            : []
        if (!isMounted.current) return
        setFiltro({
            Filiais: resposta.Filiais,
            Situacoes: resposta.Situacoes,
            Vendedores: resposta.Vendedores,
            CodigoFilialDefaultUsuario: resposta.CodigoFilialDefaultUsuario,
            VendedorLogado: resposta.VendedorLogado,
            NumeroPedido: 0,
            DataInicial: "",
            DataFinal: globalMU.converterObjetoDateParaDataFormatoEN(new Date()),
            CodigoVendedor: "",
            EstoqueReservado: "A",
            ListaProdutosSelecionados: [],
            ListaSituacoesPedido: [],
            ListaFiliaisSelecionadas: listaFiliaisSelecionada,
            ListaVendedoresSelecionados: listaVendedoresSelecionado,
            ColunaOrdenacao: "Orçamento",
            OrdemOrdenacaoDecrescente: false,
            NumeroPagina: 1
        })
        setPaginaFiltro(1)
    }, [])

    const onSelecionarTodos = useCallback(() => {
        if (!isMounted.current) return
        setOrdemProducaoSelecionadoLista(prev => {
            let listaAtual = prev || []
            listaOrdemProducaoRef.current?.Entities?.forEach((op) => {
                const achou = listaAtual.find((produtoOP) => produtoOP.Index == op.Index)
                if (!achou && !op.MensagemErro) {
                    listaAtual = [...listaAtual, op]
                }
            })
            return listaAtual.filter(op => !op.MensagemErro) // 472375
        })
    }, [])

    const handleNumeroPedidoAlterado = useCallback((numeroPedido: number) => {
        setFiltro(prev => ({ ...prev!, NumeroPedido: numeroPedido }))
    }, [])

    const onCancelarGeracaoOrdemDeProducao = () => { // 471071
        if (!isMounted.current) return



        setMostrarPesquisaProduto(false)
        setMostrarOrdemProducao(false)

        if (ordemProducaoSelecionadoLista?.length > 1) {
            globalMU.showInfoMessage("Confirme o Cancelamento dos Registros Selecionados.")
            setProcessando(true)
            setMostrarConsultaOrdemProducao(true)
            setMostrarCancelarGeracaoOP(false)
            setCancelamentoMultiplo(true)

        } else {
            setMostrarConsultaOrdemProducao(false)
            setMostrarCancelarGeracaoOP(true)
            setCancelamentoMultiplo(false)
        }
    }

    const onConfirmarCancelamentoMultiplo = async () => { // 471071

        if (!isMounted.current) return

        if (ordemProducaoSelecionadoLista?.length === 0) {
            globalMU.showWarnMessage("Nenhum produto selecionado para cancelar a geração da Ordem de Produção.")
            return
        }
        let numeroPedidoCancelado = []

        try {
            globalMU.blockUI()
            setProcessando(true)
            /* nao precisa o obter ja coloca em exclusividade
                        // coloca todos os pedidos em exclusividade
            
                        try {
                            for (const op of ordemProducaoSelecionadoLista) {
                                
                                if (!numeroPedidoCancelado.includes(op.NumeroPedido)) {
                                    
                                    const resp = await microuniversoApi.Orcamento.DefinirControleExclusividade(op.NumeroPedido, "Y")
                                    numeroPedidoCancelado.push(op.NumeroPedido)
                                }
                            }
                        }
                        catch (e) {
                            
                            tratamentoErroPadrao(e)
                            return
                        }
                            */

            try {

                let opSelecionadasListaOrdenadoPorNivelDescrescente = R.sortWith([
                    R.ascend(R.prop('NumeroPedido')),
                    R.ascend(R.prop('CodigoItem')),
                    R.descend(R.prop('Nivel'))
                ], ordemProducaoSelecionadoLista || [])

                for (const op of opSelecionadasListaOrdenadoPorNivelDescrescente) {
                    {
                        globalMU.blockUI()

                        if (!isMounted.current) break // Isso vai sair do loop

                        if (numeroPedidoCancelado.includes(op.NumeroPedido)) {

                            await microuniversoApi.Comum.excluirControleDeExclusividade(op.NumeroPedido.toString(), "PEDICLICAD")

                            numeroPedidoCancelado = numeroPedidoCancelado.filter(num => num !== op.NumeroPedido);
                        }


                        const ordemProducao = await microuniversoApi.OrdemProducao.ObterDadosOrdemProducao({
                            CodigoItemPedido: op.CodigoItem,
                            CodigoOrdemProducao: op.CodigoOrdemProducao,
                            CodigoProduto: op.CodigoProduto,
                            QuantidadeItem: op.QuantidadeItem,
                            CodigoFilial: op.CodigoFilialOP,
                            Nivel: op.Nivel

                        }, op.NumeroPedido)

                        if (ordemProducao["HasErrors"] == undefined) {



                            if (!numeroPedidoCancelado.includes(op.NumeroPedido))
                                numeroPedidoCancelado.push(op.NumeroPedido)
                            try {

                                let dados: Partial<DadosSalvarOrdemProducao> = {
                                    DataInclusao: ordemProducao.Dados == null ? globalMU.converterObjetoDateParaDataFormatoEN(new Date()) : ordemProducao.Dados.DataInclusao,

                                    CodigoOrdemProducao: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.Id : ordemProducao.Dados.Id,
                                    CodigoFilial: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoFilial : ordemProducao.Dados.CodigoFilial,
                                    CodigoSituacao: 40093, // cancelada
                                    NumeroPedido: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.NumeroPedido : ordemProducao.Dados.NumeroPedido,
                                    CodigoCliente: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoCliente : ordemProducao.Dados.CodigoCliente,
                                    CodigoProduto: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoProduto : ordemProducao.Dados.CodigoProduto,
                                    Lote: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.Lote : ordemProducao.Dados.Lote,
                                    CodigoLinha: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoLinha : ordemProducao.Dados.CodigoLinha,
                                    Quantidade: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.Quantidade : ordemProducao.Dados.Quantidade,
                                    ItemPedido: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.ItemPedido : ordemProducao.Dados.ItemPedido,
                                    DataAprovacao: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.DataAprovacao : ordemProducao.Dados.DataAprovacao,
                                    DataEntrega: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.DataEntrega : ordemProducao.Dados.DataEntrega,
                                    DataProducao: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.DataProducao : ordemProducao.Dados.DataProducao,
                                    Terceirizado: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.Terceirizado : ordemProducao.Dados.Terceirizado,
                                    CodigoFornecedor: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.CodigoFornecedor : ordemProducao.Dados.CodigoFornecedor,
                                    InformacaoAdicional: ordemProducao.Dados == null ? ordemProducao.DadosInclusao.InformacaoAdicional : ordemProducao.Dados.InformacaoAdicional,
                                }


                                let filtroSalvarOrdemProducao: Partial<OrdemProducaoApi.FiltroSalvarOrdemProducao> = {
                                    Dados: dados,
                                    DadosInsumoOrdemProducao: ordemProducao.DadosInsumoOrdemProducao,
                                    SenhaLiberacao: null,
                                    DadosHistoricoOrdemProducao: null
                                }

                                if (!isMounted.current) break // Isso vai sair do loop
                                globalMU.blockUI()
                                const resposta = await microuniversoApi.OrdemProducao.SalvarOrdemProducao(filtroSalvarOrdemProducao)

                                if (resposta?.Resultado?.Sucesso) {
                                    globalMU.showSuccessMessage(resposta?.Resultado?.MensagemSucesso)

                                }
                                else {

                                    globalMU.showErrorMessage(resposta?.Resultado?.MensagemSucesso ?? "Erro ao cancelar a ordem de produção.")
                                    break // Isso vai sair do loop
                                }
                            }
                            catch (error) {

                                globalMU.showErrorMessage(error.message)
                                break // Isso vai sair do loop
                            }


                        }
                        else {

                            break // Isso vai sair do loop
                        }


                    }
                }
            } catch (e) {

                tratamentoErroPadrao(e)
            } finally {

                //
            }


        }
        catch (erro) {

            tratamentoErroPadrao(erro)
        }
        finally {

            for (const numeroPedido of numeroPedidoCancelado) {
                try {

                    await microuniversoApi.Comum.excluirControleDeExclusividade(numeroPedido.toString(), "PEDICLICAD")
                }
                catch (e) {

                    // nao faz nada
                }

            }
            setMostrarConsultaOrdemProducao(true)
            setMostrarCancelarGeracaoOP(false)
            setCancelamentoMultiplo(false)

            setOrdemProducaoSelecionadoLista([]) // 472375
            onPesquisar(paginaFiltro, filtro!, false) // pesquisar novamente para remover o item cancelado
            setProcessando(false)
            globalMU.unblockUI()
        }

    }


    useEffect(() => {
        if (filtro?.VendedorLogado && isMounted.current) {
            setProcessando(false)
            setMostrarConsultaOrdemProducao(true)
        }
    }, [filtro?.VendedorLogado])

    useEffect(() => {
        globalMU.blockUI()
        setProcessando(true)

        const controleExclusividadeOrdemProducaoHub = $.connection.controleExclusividadeOrdemProducaoHub
        controleExclusividadeOrdemProducaoHub.client.pong = () => {
            console.log('controleExclusividadeOrdemProducaoHub => pong')
        }

        $.connection.hub.start().done(() => {
            controleExclusividadeOrdemProducaoHub.server.ping()
        })

        obterDadosParaFiltro()

        return () => {
            $.connection.hub.stop()
        }
    }, [])

    return (
        <>
            {!mostrarConsultaOrdemProducao && !mostrarOrdemProducao && !mostrarCancelarGeracaoOP && !cancelamentoMultiplo && !mostrarPesquisaProduto && (
                <span>Carregando... Aguarde!</span>
            )}

            {mostrarConsultaOrdemProducao && (
                <>
                    <Breadcrumb2Container
                        id="ConsultaOrdemDeProducaoContainer"
                        passos={passosInterno.current.set("Consulta de Orçamento para Ordem de Produção", () => { }).keysToList()}
                        exibirBotaoLimpar={false}
                        exibirBotaoVoltar={false}
                    />
                    <ConsultaOrdemDeProducao
                        filtro={filtro!}
                        pedirSenhaLiberacao={pedirSenhaLiberacao}
                        produtosFiltrados={produtosFiltrados}
                        listaOrdemProducao={listaOrdemProducao || { Entities: [] }}
                        ordemProducaoSelecionadoLista={ordemProducaoSelecionadoLista || null}
                        onErrorValidacao={globalMU.showErrorMessage}
                        onSelecionarTodos={onSelecionarTodos}
                        cancelamentoMultiplo={cancelamentoMultiplo}
                        onEditarOrdemDeProducao={() => {
                            if (processando) return
                            setMostrarPesquisaProduto(false)
                            setMostrarConsultaOrdemProducao(false)
                            setMostrarCancelarGeracaoOP(false)
                            setMostrarOrdemProducao(true)
                        }}
                        onCancelarOrdemDeProducao={onCancelarGeracaoOrdemDeProducao}
                        onConfirmarCancelamentoMultiplo={onConfirmarCancelamentoMultiplo}
                        onGerarOrdemDeProducao={onGerarOrdemDeProducao} // 472375
                        onRemoverProdutoSelecionado={onRemoverProdutoSelecionado}
                        onNumeroPedidoAlterado={handleNumeroPedidoAlterado}
                        toggleOrdemProducaoSelecionado={toggleSelecionado}
                        onSenhaValidada={onSenhaValidada}
                        processando={processando}
                        onPesquisar={onPesquisar}
                        onPesquisarProduto={() => {
                            if (processando) return
                            setMostrarPesquisaProduto(true)
                            setMostrarConsultaOrdemProducao(false)
                            setMostrarCancelarGeracaoOP(false)
                            setMostrarOrdemProducao(false)
                        }}
                        onAlterarOrdenacaoDados={onAlterarOrdenacao}
                        colunaOrdenacao={colunaOrdenacao}
                        ordemOrdenacaoDecrescente={ordemOrdenacaoDecrescente}
                    />
                </>
            )}

            {mostrarOrdemProducao && (
                <OrdemDeProducaoContainer
                    onRemover={() => removerComponenteReact("pesquisar-pedidos-region")}
                    ordemProducaoSelecionado={ordemProducaoSelecionadoLista[0]!}
                    onVoltar={() => {
                        setMostrarConsultaOrdemProducao(true)
                        setMostrarOrdemProducao(false)
                        setMostrarCancelarGeracaoOP(false)
                        onPesquisar(paginaFiltro, filtro!, false)
                        setOrdemProducaoSelecionadoLista([]) // 472375
                        setSenhaLiberacao(null) // 472375
                    }}
                    passos={passosInterno.current}
                />
            )}

            {mostrarCancelarGeracaoOP  // 471071
                && (
                    <CancelarGeracaoOrdemProducaoContainer
                        ordemProducao={ordemProducaoSelecionadoLista[0]!}
                        onRemover={() => removerComponenteReact("pesquisar-pedidos-region")}
                        onVoltar={() => {

                            setMostrarConsultaOrdemProducao(true)
                            setMostrarCancelarGeracaoOP(false)
                            setMostrarOrdemProducao(false)
                            setOrdemProducaoSelecionadoLista([]) // 472375
                            setSenhaLiberacao(null) // 472375

                            onPesquisar(paginaFiltro, filtro!, false) // pesquisar novamente para remover o item cancelado
                        }}
                        passos={passosInterno.current}
                    />
                )}


            {mostrarPesquisaProduto && (
                <PaginaPesquisaProdutoContainer
                    pesquisandoApenasParaFiltroProdutosLupa={true}
                    chamadoParaInserirProdutoNoOrcamento={false}
                    chamadoPeloTrocarProduto={false}
                    adicionarProdutos={(produtosSelecionados) => {
                        const prodFiltrado = produtosSelecionados?.map(produto => ({
                            Codigo: produto.Codigo,
                            Descricao: produto.Descricao?.trimEnd(),
                            CodigoProduto: produto.CodigoProduto?.trimEnd(),
                        } as ProdutoFiltrado))

                        setProdutosFiltrados(prodFiltrado || [])
                        setFiltro(prev => ({
                            ...prev!,
                            ListaProdutosSelecionados: prodFiltrado?.map(p => p.Codigo) || []
                        }))
                        setMostrarConsultaOrdemProducao(true)
                        setMostrarCancelarGeracaoOP(false)
                        setMostrarPesquisaProduto(false)
                    }}
                    ocultarSubPaginas={true}
                    passos={passosInterno.current}
                    desabilitarPesquisarHistorico
                    esconderForaEstoque={true}
                    desabilitarInserirContinuar={true}
                    ocultarBarraPesquisa={true}
                    onVoltar={() => {
                        setMostrarConsultaOrdemProducao(true)
                        setMostrarCancelarGeracaoOP(false)
                        setMostrarPesquisaProduto(false)
                    }}
                    regiaoRenderizada={"ordem-de-producao-region"}
                />
            )}

        </>
    )
}

window.ConsultaOrdemDeProducaoContainer = ConsultaOrdemDeProducaoContainer